import { FC } from "react"
import { Button } from "@unlimint/admin-ui-kit"

import { FormError } from "view/components/FormError"

import * as S from "./styled"

type TConfirmSaveThemesProps = {
  error: unknown | null
  isSubmitting: boolean
  onCancel(): void
  onSubmit(): void
}

export const ConfirmSaveThemes: FC<TConfirmSaveThemesProps> = ({
  error,
  isSubmitting,
  onCancel,
  onSubmit,
}) => {
  return (
    <S.Wrapp>
      <S.Title>Do you want to save the changes?</S.Title>

      <S.ButtonsBlock>
        <Button size="small" color="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          size="small"
          type="submit"
          onClick={onSubmit}
          disabled={isSubmitting}
        >
          Save changes
        </Button>
      </S.ButtonsBlock>

      <FormError error={error} align="center" />
    </S.Wrapp>
  )
}
